import { RootState } from '@redux/types';
import { TypedUseSelectorHook, useSelector as useSelectorGeneric } from 'react-redux';

const useSelector: TypedUseSelectorHook<RootState> = useSelectorGeneric;

export default useSelector;
